import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS,
  LOCAL_STORAGE,
  TYPE_FIELDS,
  VJSF_OPTIONS
} from "@/shared/constants/FormConstants";
import { QuerySend } from "@/shared/models/FormQuerySend";
import { Http } from "@status/codes";
import { Component, Inject, Watch, Prop } from "vue-property-decorator";
import { STYLE_CLASSES } from "../../shared/constants/StyleConstants";
import { NOTIFICATION_CONFIG } from "../Notification/constants/NotificationConstants";
import { ServiceTemplateHeader } from "../ServiceTemplate/models/ServiceTemplateHeader";
import { ServiceTemplateService } from "../ServiceTemplate/services/ServiceTemplateService";
import { UserQuery } from "../User/models/UserQuery";
import { UserStatus } from "../User/models/UserStatus";
import { UserService } from "../User/services/UserService";
import { ORDER_CONSTANTS } from "../Orders/constants/OrderConstants";
import { FieldOrder } from "../Orders/models/FieldOrder";
import { OrderService } from "../Orders/services/OrderService";
import { FullSchema } from "@/shared/models/FullSchema";
import { GroupFullSchema } from "@/modules/InfoGroup/models/GroupFullSchema";
import { PhoneSchema } from "@/shared/models/PhoneSchema";
import { LIST_ACCESS, LIST_CONSTANTS } from "../List/constants/ListConstants";
import { ListService } from "../List/services/ListService";
import { OrderListDataView } from "../Orders/models/OrderListDataView";
import { PhonePayload } from "../InfoGroup/models/PhonePayload";
import ModalTemplate from "../../shared/components/ModalTemplate/ModalTemplate.vue";
import { MedicalOrderService } from "./services/MedicalOrderService";
import { ServiceTemplateModel } from "../ServiceTemplate/models/ServiceTemplateModel";
import { SectionGroup } from "../ServiceTemplate/models/SectionGroup";
import { PhoneModel } from "../../shared/models/PhoneModel";
import { FORMS_CONSTANTS } from "../Forms/constants/FormsConstants";
import { CupsPriceLevelService } from "../CupsPriceLevels/services/CupsPriceLevelService";
import { Utils } from "@/shared/utils/utils";
import {
  SERVICES_CONTANTS,
  SERVICE_LIST_IDS,
  SERVICE_FILTERS,
  SERVICE_STATES
} from "../Services/constants/ServicesConstants";
import { ArrayByKeys } from "@/shared/models/ArrayByKeys";
import { SectionGroupDetail } from "../ServiceTemplate/models/SectionGroupDetail";
import { Service } from "../Services/models/Service";
import { MedicalOrderModel } from "./models/MedicalOrderModel";
import { FieldMedicalOrderSchemaKey } from "./models/FieldMedicalOrderSchemaKey";
import { TitleList } from "@/shared/models/TitleList";
import { SectionGroupData } from "./models/SectionGroupData";
import { SavedItems } from "./models/SavedSessions";
import {
  CLOSE_ORDER_MODAL,
  MEDICAL_ORDER_CONSTANTS,
  NO_PATIENT,
  FILTER_SEARCH_USER_MEDICAL_ORDER,
  FILTER_QUERY_DEFAULT_MEDICAL_ORDER,
  MEDICAL_ORDER_ACCESS,
  ORDER_ASSINGNED,
  FIELDS_ORDER_TO_PRELOAD,
  FIELDS_MAPED_FROM_USER
} from "./constants/MedicalOrderConstants";
import VuePhoneNumberInput from "vue-phone-number-input";
import {
  GENERAL_CONSTANTS,
  NAME_FINDERS
} from "../../shared/constants/GeneralConstants";
import StepperViewer from "@/modules/ServiceTemplate/components/StepperViewer/StepperViewer.vue";
import { MedicalOrderField } from "./models/MedicalOrderField";
import { MedicalOrderFieldsMap } from "./models/MedicalOrderFieldsMap";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import InfoModalTemplate from "@/shared/components/InfoModalTemplate/InfoModalTemplate.vue";
import GenericSearchBar from "@/shared/components/GenericSearchBar/GenericSearchBar.vue";
import { Filter } from "../Dashboards/AdminDashboard/models/Filter";
import lodash from "lodash";
import { PreventKey } from "@/shared/mixins/mixins";
import { FORM_TEMP_CONSTANTS } from "../FormTemplate/constants/FormTemplateConstants";
import SearchOneFilter from "./../../shared/components/GenericSearchBar/components/SearchOneFilter/SearchOneFilter.vue";
import { QueryFilter } from "@/shared/components/GenericSearchBar/model/FilterOneItem";
import { USER_ACCESS } from "../User/constants/UserConstants";
import { SERVICE_TEMPLATES_ACCESS } from "../ServiceTemplate/constants/ServiceTemplateConstants";
import { CUPS_ACCESS } from "../CupsPriceLevels/constants/CupsPriceLevelConstants";
import { UserInformationModel } from "../User/models/UserInformationModel";
import { KeyValue } from "@/shared/models/KeyValue";
import { CampusService } from "../Campus/services/CampusService";

@Component({
  name: "MedicalOrder",
  components: {
    ModifVJsfInput,
    VuePhoneNumberInput,
    ModalTemplate,
    StepperViewer,
    InfoModalTemplate,
    SearchOneFilter,
    GenericSearchBar
  }
})
export default class MedicalOrder extends PreventKey {
  @Inject() userService!: UserService;
  @Inject() serviceTemplateService!: ServiceTemplateService;
  @Inject() campusService!: CampusService;
  @Inject() orderService!: OrderService;
  @Inject() listService!: ListService;
  @Inject() medicalOrderService!: MedicalOrderService;
  @Inject() cupsPriceLevelService!: CupsPriceLevelService;
  @Prop() isOnModal?: boolean;
  @Prop() isOnProfile?: boolean;
  @Prop() userId?: string;

  TITLE = MEDICAL_ORDER_CONSTANTS.TITLE;
  USER_LABEL = MEDICAL_ORDER_CONSTANTS.LABELS.USER;
  USER_HINT = MEDICAL_ORDER_CONSTANTS.HINT.USER;
  SELECT_SERVICE_TITLE = MEDICAL_ORDER_CONSTANTS.SELECT_SERVICE_TEMPLATE;
  CONFIG_TITLE = MEDICAL_ORDER_CONSTANTS.SERVICE_CONFIG_TEXT;
  INFO_TEXT = MEDICAL_ORDER_CONSTANTS.MESSAGES.INFO;
  WARNING_TEXT = MEDICAL_ORDER_CONSTANTS.MESSAGES.WARNING;
  ASSIGN_SERVICE_LABEL = MEDICAL_ORDER_CONSTANTS.LABELS.ASSIGN_SERVICE;
  LOAD_MORE_TEXT = NOTIFICATION_CONFIG.LABEL.LOAD_MORE_TEXT;
  STATE_COMPLETE = MEDICAL_ORDER_CONSTANTS.STATES.COMPLETE;
  CUSTOMIZED = GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED;
  STATE_LABEL = ORDER_CONSTANTS.LABELS.STATE;
  DIAG_CODE = ORDER_CONSTANTS.LABELS.DIAG_CODE;
  CANCEL_VALUE = ORDER_CONSTANTS.LABELS.CANCEL_VALUE;
  SERVICE_VALUE = ORDER_CONSTANTS.LABELS.SERVICE_VALUE;
  EXTERNAL_NUMBER = ORDER_CONSTANTS.LABELS.EXTERNAL_NUMBER;
  PRICE_LEVEL = ORDER_CONSTANTS.LABELS.PRICE_LEVEL;
  CUPS = ORDER_CONSTANTS.LABELS.CUPS;
  EVENT = ORDER_CONSTANTS.LABELS.EVENT;
  BILL_TYPE = ORDER_CONSTANTS.LABELS.BILL_TYPE;
  CAMPUS = ORDER_CONSTANTS.LABELS.CAMPUS;
  DESCRIPTION = ORDER_CONSTANTS.LABELS.DESCRIPTION;
  ORDER_TYPE = ORDER_CONSTANTS.LABELS.ORDER_TYPE;
  SELECTED_CHIP = STYLE_CLASSES.CHIP_COLOR.ACCENT;
  INT_NAME = ORDER_CONSTANTS.PREVIEW_EXAMPLE.INTERNAL_NAME.TEXT;
  EXT_NAME = ORDER_CONSTANTS.PREVIEW_EXAMPLE.EXTERNAL_NAME.TEXT;
  CAT_NAME = ORDER_CONSTANTS.PREVIEW_EXAMPLE.CATEGORY.TEXT;
  CUPS_NAME = ORDER_CONSTANTS.PREVIEW_EXAMPLE.CUPS.TEXT;
  SAVE_BUTTON = FORM_CONSTANTS.BUTTON.SAVE;
  CANCEL_BUTTON = FORM_CONSTANTS.BUTTON.CANCEL;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  END_ORDER = MEDICAL_ORDER_CONSTANTS.END_ORDER;
  ADD_BUTTON = FORM_CONSTANTS.BUTTON.ADD;
  VIEW_BUTTON = FORM_CONSTANTS.BUTTON.PREVIEW;
  NO_MULTIPLE_INSTANCES = GENERAL_CONSTANTS.TEXTS.NO_MULTIPLE_INSTANCES;
  NOT_ALLOWED = GENERAL_CONSTANTS.TEXTS.NOT_ALLOWED;
  USER_MEDICAL_ORDEN_KEY = NAME_FINDERS.USER_MEDICAL_ORDEN;
  SEARCH_MEDICAL_ORDER_KEY = NAME_FINDERS.MEDICAL_ORDER;
  GROUP_TEXT = GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TEXT;

  cardClass = STYLE_CLASSES.CARD;
  roundBtnClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;

  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  notBlankSpaces = [FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR];
  userFilters = NOTIFICATION_CONFIG.USER_FILTERS;
  orderTypes = MEDICAL_ORDER_CONSTANTS.ORDER_TYPES;
  assignTypes = GENERAL_CONSTANTS.ASSIGN_TYPES_LIST;
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  model: any = {};
  modalTextOrder = "";
  modalTitleOrder = "";
  listUsers: UserStatus[] = [];
  searchUser = "";
  userLastRef = "";
  userFilter = 2;
  userChosen: UserStatus | string = "";
  loadingData = false;
  filterItems: {
    name?: string[];
    type?: string[];
    category?: string[];
  } = {};
  filterArray: Filter[] = lodash.cloneDeep(SERVICE_FILTERS) as Filter[];
  serviceTemplates: ServiceTemplateHeader[] = [];
  chosenServiceTemp: ServiceTemplateHeader | string = "";
  openedPanel: number[] = [0];
  existOrder = false;
  phoneSchemaCharged = false;
  fieldsOrder: FieldOrder[] = [];
  orderSchema: FullSchema = {
    type: "object",
    properties: {},
    required: []
  };
  schema: GroupFullSchema = {
    allOf: [this.orderSchema],
    type: "object"
  };
  phoneTypeList: PhoneSchema[] = [];
  listData: OrderListDataView = {
    stateList: { data: [] },
    billType: { data: [] },
    campus: { data: [] },
    diagnosticPrimaryCode: { data: [] }
  };
  options = VJSF_OPTIONS;
  phoneComplete = false;
  modalDialogOrder = false;
  showOrderForm = false;
  serviceTemplate: ServiceTemplateModel | string = "";
  serviceTempType = "";
  groupSectionSelected: SectionGroup | string = "";
  groupSections: SectionGroup[] | undefined = [];
  sessionsFormTemps: SectionGroupDetail[] = [];
  currentSectionGroups: SectionGroup[] = [];
  currentItems: SectionGroupDetail[] = [];
  savedItems: SavedItems[] = [];
  serviceAssignType = "";
  groupSectionAssignType = "";
  cups = "";
  priceLvls: ArrayByKeys[] = [];
  externalName = "";
  priceLevel = "";
  billType = "";
  orderState = "";
  orderCampus = { id: "", name: "" };
  diagnosticPrimaryCode = "";
  orderDescription = "";
  orderType = "";
  orderEvent = "";
  orderServiceValue = "";
  orderCancelValue = "";
  orderExternalNumberValue = "";
  orderTracking = "";
  dialogStepperViewer = false;
  componentStepperViewerKey = 0;
  serviceTemplateData: ServiceTemplateModel = new ServiceTemplateModel();
  validFormOrder = false;
  validCustomFields = false;
  clearSelectUser = 0;

  itemFilter = {
    ...FILTER_SEARCH_USER_MEDICAL_ORDER,
    getData: this.getUserData
  };

  patientModelData: KeyValue[] = [];
  userModelData: KeyValue[] = [];
  vjsfKey = 0;

  serviceCups: ArrayByKeys[] = [];
  cupsSelected = "";

  async getUserData(query: QueryFilter): Promise<UserStatus[]> {
    let listPatient: UserStatus[] = [];
    try {
      const filterQuery = {
        ...query,
        ...FILTER_QUERY_DEFAULT_MEDICAL_ORDER
      };
      const responseData = await this.userService.getUserByFilters(filterQuery);
      if (responseData.code === Http.Found && responseData.data) {
        listPatient = responseData.data.userArray;
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
    return listPatient;
  }

  selectItem(item: UserStatus) {
    if (item.id) {
      this.setUser(item);
    } else {
      this.deleteUserChosen();
    }
  }

  async mounted() {
    await this.getTemplate();
    await this.getSchema();
    this.filterArray[0].secondaryFilters[1].options = await Utils.getListAndMapItAsSecondaryFilterOptions(
      SERVICE_LIST_IDS.CATEGORY
    );

    this.phoneSchemaCharged = true;
    if (this.userId && this.userId != "") {
      this.managePreSetUser();
    }
  }

  async preloadData() {
    await this.getUsersFromOrder();
    for (const property in this.model) {
      switch (property) {
        case FIELDS_ORDER_TO_PRELOAD.CUPS:
          this.model[property] = this.cups;
          break;
        case FIELDS_ORDER_TO_PRELOAD.DATE_CREATED:
          this.model[property] = new Date();
          break;
        case FIELDS_ORDER_TO_PRELOAD.PATIENT_IDENTIFICATION_TYPE:
          this.model[property] = this.patientModelData.find(
            e => e.key == FIELDS_MAPED_FROM_USER.IDENTIFICATION_TYPE
          )?.name;
          break;
        case FIELDS_ORDER_TO_PRELOAD.PATIENT_SEX:
          this.model[property] = this.patientModelData.find(
            e => e.key == FIELDS_MAPED_FROM_USER.SEX
          )?.name;
          break;
        case FIELDS_ORDER_TO_PRELOAD.PATIENT_NAME:
          this.model[property] =
            this.patientModelData.find(
              e => e.key == FIELDS_MAPED_FROM_USER.FIRST_NAME
            )?.name +
            " " +
            this.patientModelData.find(
              e => e.key == FIELDS_MAPED_FROM_USER.SECOND_NAME
            )?.name;
          break;
        case FIELDS_ORDER_TO_PRELOAD.PATIENT_LASTNAME:
          this.model[property] =
            this.patientModelData.find(
              e => e.key == FIELDS_MAPED_FROM_USER.FIRST_LASTNAME
            )?.name +
            " " +
            this.patientModelData.find(
              e => e.key == FIELDS_MAPED_FROM_USER.SECOND_LASTNAME
            )?.name;
          break;
        case FIELDS_ORDER_TO_PRELOAD.PATIENT_PHONE:
          this.model[property] = this.patientModelData.find(
            e => e.key == FIELDS_MAPED_FROM_USER.PHONE
          )?.name;
          break;
        case FIELDS_ORDER_TO_PRELOAD.USER_NAME:
          this.model[property] =
            this.patientModelData.find(
              e => e.key == FIELDS_MAPED_FROM_USER.FIRST_NAME
            )?.name +
            " " +
            this.patientModelData.find(
              e => e.key == FIELDS_MAPED_FROM_USER.SECOND_NAME
            )?.name +
            " " +
            this.patientModelData.find(
              e => e.key == FIELDS_MAPED_FROM_USER.FIRST_LASTNAME
            )?.name +
            " " +
            this.patientModelData.find(
              e => e.key == FIELDS_MAPED_FROM_USER.SECOND_LASTNAME
            )?.name;
          break;
      }
    }
  }

  async getUsersFromOrder() {
    const patientResponse = await this.userService.getUserById(
      (this.userChosen as UserStatus).id
    );

    if (patientResponse.data) {
      this.patientModelData = await this.mapPropertiesUser(
        patientResponse.data
      );
    }

    const currentUserId = localStorage.getItem(LOCAL_STORAGE.UID) as string;

    const userResponse = await this.userService.getUserById(currentUserId);

    if (userResponse.data) {
      this.userModelData = await this.mapPropertiesUser(userResponse.data);
    }
  }

  mapPropertiesUser(userInfo: UserInformationModel) {
    const properties = userInfo.userData?.schema?.schema.allOf[0].properties;
    const phoneComponentList = userInfo.userData?.schema?.phoneComponentList;

    const modelData = [];
    for (const property in properties) {
      modelData.push({
        key: property,
        name: userInfo.userData?.fields[property] as string
      });
    }
    phoneComponentList?.forEach(phone => {
      modelData.push({
        key: phone.title,
        name: phone.model as string
      });
    });
    return modelData;
  }

  get assignGroupSectionLabel(): string {
    if (
      (this.serviceTemplate as ServiceTemplateModel).type ==
      GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TYPE
    )
      return SERVICES_CONTANTS.LABEL.ASSIGN_GROUP;
    else return SERVICES_CONTANTS.LABEL.ASSIGN_SECTION;
  }

  get sessionsFormTempLabel(): string {
    if (
      (this.serviceTemplate as ServiceTemplateModel).type ==
      GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TYPE
    )
      return SERVICES_CONTANTS.LABEL.SESSIONS;
    else return SERVICES_CONTANTS.LABEL.FORM_TEMPS;
  }

  async getUsers(ref: boolean) {
    const query: UserQuery = {
      userState: "Activo",
      externalUser: true
    };

    if (ref) query.idReference = this.userLastRef;

    switch (this.userFilter) {
      case 0:
        query.userName = this.searchUser;
        break;
      case 1:
        query.userPhone = this.searchUser;
        break;
      case 2:
        query.userDocument = this.searchUser;
        break;
    }
    try {
      const responseData = await this.userService.getUserByFilters(query);

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.listUsers = this.listUsers.concat(responseData.data.userArray);
        this.userLastRef = responseData.data.lastReference;
      } else {
        this.listUsers = [];
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }
  @Watch("userId")
  async resetPresetUser() {
    if (this.userId && this.userId != "") {
      await this.managePreSetUser();
    }
  }
  setUser(user: UserStatus) {
    this.cleanServiceConfig();
    this.userChosen = user;
  }

  async getServiceTemplates(data: any) {
    this.loadingData = true;
    const filterQuery: QuerySend = {
      state: FORM_CONSTANTS.STATE.ACTIVE
    };

    delete data["mainFilterKey"];

    this.filterItems = { ...data };

    try {
      if (this.filterItems.name)
        filterQuery.internalName = this.filterItems.name[0];

      if (this.filterItems.type) filterQuery.type = this.filterItems.type[0];

      if (this.filterItems.category)
        filterQuery.category = this.filterItems.category[0];

      if (
        filterQuery.internalName ||
        filterQuery.type ||
        filterQuery.category
      ) {
        const response = await this.serviceTemplateService.getServiceTemplateWithFilters(
          { ...filterQuery, requiredPriorOrder: true }
        );

        if (response.code === Http.Found && response.data) {
          this.serviceTemplates = response.data.serviceTemplates;
        } else {
          this.serviceTemplates = [];
          Snackbar.popInfo(response.message);
        }
      } else {
        this.serviceTemplates = [];
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICE_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }

    this.loadingData = false;
  }

  async setServiceTemp(item: ServiceTemplateHeader) {
    this.openedPanel = [];
    this.chosenServiceTemp = item;

    this.cleanServiceConfig();

    await this.validateOrder(
      item.id as string,
      (this.userChosen as UserStatus).id
    );

    await this.getServiceTemplate(item.id as string);
    Utils.scrollToElement(
      MEDICAL_ORDER_CONSTANTS.IDS.MEDICAL_ORDER_PRICE_LEVEL_LIST_SEL,
      this
    );
    this.orderTracking =
      ORDER_ASSINGNED +
      (this.serviceTemplate as ServiceTemplateModel).internalName;

    await this.preloadData();
    this.vjsfKey++;
  }

  async getServiceTemplate(id: string) {
    try {
      const responseData = await this.serviceTemplateService.getServiceTemplateById(
        id
      );

      if (responseData.code == Http.Found && responseData.data !== undefined) {
        this.serviceTemplate = responseData.data;
        this.groupSections =
          responseData.data.type === GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TYPE
            ? responseData.data.groups
            : responseData.data.sections;
        this.serviceTempType =
          responseData.data.type === GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TYPE
            ? GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TEXT
            : GENERAL_CONSTANTS.SERVICE_TYPES.SECTION_TEXT;

        this.currentSectionGroups = this.groupSections as SectionGroup[];
        this.fillSavedItems();
        if (this.serviceTempType == this.GROUP_TEXT) {
          const arrayCups: string[] = [];
          for (const iterator of this.currentSectionGroups) {
            arrayCups.push(iterator.cups as string);
          }
          await this.getCupsByIds(arrayCups);
        } else {
          await this.getPriceLevelsByCup(this.serviceTemplate.cups as string);
        }
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${CUPS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getPriceLevelsByCup(cups: string) {
    try {
      const priceLevels = await this.cupsPriceLevelService.getCupsPriceLevelById(
        cups
      );

      if (priceLevels.code === Http.Found && priceLevels.data) {
        this.externalName = priceLevels.data.externalName;
        this.cups = priceLevels.data.cups;
        this.priceLvls = Utils.getArrayByKeys(
          priceLevels.data.clients,
          SERVICES_CONTANTS.ATTRIBUTES
        );
      } else {
        this.cups = "";
        this.priceLvls = [];
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${CUPS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  @Watch("cupsSelected")
  async onSelectCups() {
    if (this.serviceTempType == this.GROUP_TEXT) {
      await this.getPriceLevelsByCup(this.cupsSelected);
    }
  }

  fillSavedItems() {
    this.currentSectionGroups.forEach(item => {
      this.savedItems.push({
        key: item.key,
        type: GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED,
        selected:
          this.serviceTempType === this.GROUP_TEXT
            ? (item.sessions as SectionGroupDetail[])
            : (item.formTemplates as SectionGroupDetail[])
      });
    });
  }

  cleanServiceConfig() {
    this.model = {};
    this.orderExternalNumberValue = "";
    this.groupSectionSelected = "";
    this.groupSections = [];
    this.sessionsFormTemps = [];
    this.currentSectionGroups = [];
    this.currentItems = [];
    this.savedItems = [];
    this.serviceAssignType = "";
    this.groupSectionAssignType = "";
    this.showOrderForm = false;
    this.existOrder = false;
    this.priceLevel = "";
    this.billType = "";
    this.orderState = "";
    this.orderCampus = { id: "", name: "" };
    this.diagnosticPrimaryCode = "";
    this.orderDescription = "";
    this.orderType = "";
    this.orderEvent = "";
    this.orderServiceValue = "";
    this.orderCancelValue = "";
    this.serviceTemplates = [];
    this.serviceTemplate = "";
    this.validCustomFields = false;
    this.cupsSelected = "";
  }

  async validateOrder(serviceTemp: string, user: string) {
    try {
      const responseData = await this.medicalOrderService.checkMedicalOrderByServiceTemplate(
        serviceTemp,
        user
      );

      if (responseData.code === Http.NotFound) {
        this.existOrder = false;
        this.showOrderForm = true;
        this.openedPanel = [1];
      } else if (responseData.code === Http.Found) {
        this.existOrder = true;
        this.showOrderForm = true;
        this.openedPanel = [1];
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MEDICAL_ORDER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getTemplate() {
    try {
      const responseData = await this.orderService.getTemplate();

      if (responseData.code == Http.Found && responseData.data !== undefined) {
        this.fieldsOrder = responseData.data.fields;
        this.fieldsOrder = this.fieldsOrder.filter(field => {
          if (field.visible) return field;
        });

        for (const listRef of ORDER_CONSTANTS.DATA_LIST_NAMES) {
          if (responseData.data[listRef as keyof typeof responseData.data])
            await this.getListData(
              responseData.data[
                listRef as keyof typeof responseData.data
              ] as string,
              listRef
            );
        }
        this.getCampus();
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MEDICAL_ORDER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getCampus() {
    try {
      const campusResponse = await this.campusService.getAllCampus();
      if (campusResponse.code) {
        this.listData.campus.data = campusResponse.data as {
          key: string;
          name: string;
        }[];
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MEDICAL_ORDER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getSchema() {
    try {
      const responseData = await this.orderService.getOrderTempSchema();

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.schema = responseData.data;
        for (const i in this.schema.allOf[0].properties) {
          if (this.fieldsOrder.findIndex(field => field.key == i) == -1) {
            delete this.schema.allOf[0].properties[i];
          }
        }
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MEDICAL_ORDER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  @Watch("fieldsOrder")
  loadSchema() {
    this.orderSchema.required = [];
    this.orderSchema.properties = {};
    this.fieldsOrder.map(field => {
      this;
      Object.assign(this.orderSchema.properties, {
        [field.key]: field.schema
      });
      field.required ? this.orderSchema.required?.push(field.key) : null;
    });

    if (this.phoneSchemaCharged) {
      this.getPhoneSchema();
      this.phoneSchemaCharged = false;
    }
  }

  validateRequired(index: number): string {
    if (
      this.phoneTypeList[index].required == true &&
      !this.phoneTypeList[index].model
    ) {
      return "red";
    } else {
      return "#0B3352";
    }
  }

  getPhoneSchema() {
    const result = this.fieldsOrder.filter(
      field => field.type == ORDER_CONSTANTS.PHONE_TYPE
    );

    result.forEach(element => {
      this.phoneTypeList.push({
        slot: `custom-${element.key}`,
        title: element.schema.title,
        model: "",
        countryCode: "",
        countryCallingCode: "",
        required: element.required,
        enabled: element.editable,
        formattedNumber: ""
      });
    });
  }

  async getListData(id: string, name: string) {
    try {
      const responseData = await this.listService.getListById(id);

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        responseData.data.options.forEach(option => {
          const item =
            name === "stateList"
              ? { key: option.id, name: option.title }
              : option.title;

          this.listData[name].data.push(
            item as string & { key: string; name: string }
          );
        });
      } else {
        Snackbar.popInfo(LIST_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${LIST_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }
  clearFilterSelect() {
    this.clearSelectUser = 1 - this.clearSelectUser;
  }

  deleteUserChosen() {
    this.userChosen = "";
    this.clearFilterSelect();
    this.cleanServiceConfig();
  }

  onUpdate(payload: PhonePayload, index: number) {
    this.phoneTypeList[index].countryCode = payload.countryCode;
    this.phoneTypeList[index].countryCallingCode = payload.countryCallingCode;
    this.phoneTypeList[index].isValid = payload.isValid;
    this.phoneTypeList[index].formattedNumber = payload.formattedNumber
      ? payload.formattedNumber
      : "";
  }

  getFieldsModel(): MedicalOrderFieldsMap {
    const fields: MedicalOrderFieldsMap = {};
    const schemaFields: FieldMedicalOrderSchemaKey = {};
    const prop = this.schema.allOf.map(g => g.properties);

    prop.forEach(e => Object.assign(schemaFields, e));

    for (const property in this.model) {
      if (schemaFields[property]) {
        const fieldModel: MedicalOrderField = {
          title: schemaFields[property].title,
          value:
            typeof this.model[property] == FORM_TEMP_CONSTANTS.FIELD_TYPE.STRING
              ? this.model[property].trim()
              : this.model[property]
        };

        switch (schemaFields[property].typeField) {
          case TYPE_FIELDS.LIST: {
            const titleOption: TitleList[] = [];
            let scoreSelectValue = null;
            const display = schemaFields[property]["x-display"];

            switch (display) {
              case FORMS_CONSTANTS.FIELD.RADIO:
              case FORMS_CONSTANTS.FIELD.SELECT: {
                const listOption = schemaFields[property].oneOf?.find(
                  item => item.const === this.model[property]
                );

                titleOption.push({
                  type: display,
                  title: listOption?.title || "",
                  value: listOption?.const || ""
                });

                scoreSelectValue = listOption?.score;
                break;
              }
              case FORMS_CONSTANTS.FIELD.CHECKBOX: {
                for (const checkItem in this.model[property]) {
                  const listOption = schemaFields[property].items?.oneOf?.find(
                    item => item.const === this.model[property][checkItem]
                  );

                  titleOption.push({
                    title: listOption?.title || "",
                    value: listOption?.const || "",
                    type: FORMS_CONSTANTS.FIELD.CHECKBOX
                  });
                }
                scoreSelectValue = null;
                break;
              }
              default: {
                throw Error;
              }
            }

            fieldModel.listTemplate = schemaFields[property].listTemplate;
            fieldModel.titleSelectValue = titleOption;
            fieldModel.scoreSelectValue = scoreSelectValue;
            break;
          }
          case TYPE_FIELDS.PHONE: {
            const indexPhone = this.phoneTypeList.findIndex(
              p => p.slot === `custom-${property}`
            );

            const phoneModel: PhoneModel = {
              countryCode: this.phoneTypeList[indexPhone].model
                ? this.phoneTypeList[indexPhone].countryCode
                : "",
              countryCallingCode: this.phoneTypeList[indexPhone].model
                ? this.phoneTypeList[indexPhone].countryCallingCode
                : "",
              model: this.phoneTypeList[indexPhone].model
            };

            fieldModel.value = this.phoneTypeList[indexPhone].formattedNumber;
            fieldModel.phoneModel = phoneModel;
            break;
          }
        }
        fields[property] = fieldModel;
      }
    }
    return fields;
  }

  @Watch("phoneTypeList", { deep: true })
  validateRequiredPhone() {
    const invalidPhones = this.phoneTypeList.filter(
      p => (p.required && !p.isValid) || (!p.required && p.model && !p.isValid)
    );

    if (invalidPhones.length > 0) {
      this.phoneComplete = false;
    } else {
      this.phoneComplete = true;
    }
  }

  handleModalAccept() {
    this.modalDialogOrder = false;

    if (
      this.modalTitleOrder === FORM_MESSAGES.CANCEL_MODAL.TITLE &&
      !this.isOnModal
    ) {
      this.$router.go(-1);
    } else if (
      this.isOnModal &&
      this.modalTitleOrder === FORM_MESSAGES.CANCEL_MODAL.TITLE
    ) {
      this.clearModal();
      this.$emit(CLOSE_ORDER_MODAL);
    } else this.saveOrder();
  }

  handleModalCancel() {
    this.modalDialogOrder = false;
  }

  confirmDialog(isSave: boolean) {
    if (isSave) {
      this.modalTitleOrder = FORM_MESSAGES.SAVE_MODAL.TITLE;
      this.modalTextOrder = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
    } else {
      this.modalTitleOrder = FORM_MESSAGES.CANCEL_MODAL.TITLE;
      this.modalTextOrder = FORM_MESSAGES.CANCEL_MODAL.MESSAGE;
    }
    this.modalDialogOrder = true;
  }

  @Watch("groupSectionSelected")
  getFormSessions() {
    if (
      (this.serviceTemplate as ServiceTemplateModel).type ===
      GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TYPE
    ) {
      this.sessionsFormTemps = (this
        .serviceTemplate as ServiceTemplateModel).groups?.find(
        i => i.key === (this.groupSectionSelected as SectionGroup).key
      )?.sessions as SectionGroupDetail[];
    } else {
      this.sessionsFormTemps = (this
        .serviceTemplate as ServiceTemplateModel).sections?.find(
        i => i.key === (this.groupSectionSelected as SectionGroup).key
      )?.formTemplates as SectionGroupDetail[];
    }

    const existGroup = this.currentSectionGroups.find(
      i => i.key === (this.groupSectionSelected as SectionGroup).key
    );
    const dataSelected = this.savedItems.find(
      i => i.key === (this.groupSectionSelected as SectionGroup).key
    );

    if (existGroup && dataSelected) {
      this.groupSectionAssignType = dataSelected.type.slice();
      this.currentItems = [...dataSelected.selected];
    } else {
      this.groupSectionAssignType = "";
      this.currentItems = [];
    }
  }

  setSectionGroup() {
    if (this.groupSectionAssignType === "")
      return Snackbar.popInfo(
        (this.serviceTemplate as ServiceTemplateModel).type ===
          GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TYPE
          ? SERVICES_CONTANTS.MESSAGE.SELECT_ASSIGN_GROUP
          : SERVICES_CONTANTS.MESSAGE.SELECT_ASSIGN_SECTION
      );
    if (
      this.groupSectionAssignType ===
        GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED &&
      this.currentItems.length === 0
    )
      return Snackbar.popInfo(
        (this.serviceTemplate as ServiceTemplateModel).type ===
          GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TYPE
          ? SERVICES_CONTANTS.MESSAGE.SELECT_SESSIONS
          : SERVICES_CONTANTS.MESSAGE.SELECT_FORM_TEMPS
      );

    if (
      !this.currentSectionGroups.find(
        i => i.key === (this.groupSectionSelected as SectionGroup).key
      )
    )
      this.currentSectionGroups.push(this.groupSectionSelected as SectionGroup);

    const valueExist = this.savedItems.find(
      i => i.key === (this.groupSectionSelected as SectionGroup).key
    );

    if (valueExist) {
      valueExist.selected =
        this.groupSectionAssignType === GENERAL_CONSTANTS.ASSIGN_TYPE.COMPLETE
          ? []
          : [...this.currentItems];
      valueExist.type = this.groupSectionAssignType.slice();
    } else {
      this.savedItems.push({
        key: (this.groupSectionSelected as SectionGroup).key,
        selected:
          this.groupSectionAssignType === GENERAL_CONSTANTS.ASSIGN_TYPE.COMPLETE
            ? []
            : [...this.currentItems],
        type: this.groupSectionAssignType.slice()
      });
    }

    this.currentItems = [];
    this.groupSectionSelected = "";
    this.groupSectionAssignType = "";
  }

  onTagSelected(id: string) {
    this.groupSectionSelected =
      this.currentSectionGroups.find(i => i.key === id) ?? "";
  }

  onTagClosed(index: number) {
    this.currentSectionGroups.splice(index, 1);
    this.savedItems.splice(index, 1);
    this.groupSectionSelected = "";
    this.groupSectionAssignType = "";
    this.currentItems = [];
  }

  @Watch("priceLevel")
  setPrice() {
    const price = this.priceLvls.find(p => p.key === this.priceLevel);
    this.orderServiceValue = price?.price;
  }

  convertSectionGroups(): SectionGroupData[] {
    const data: SectionGroupData[] = [];

    if (
      (this.serviceTemplate as ServiceTemplateModel).type ===
      GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TYPE
    ) {
      this.savedItems.forEach(group => {
        data.push({
          key: group.key,
          sessions: group.selected.map(item => item.id)
        });
      });
    } else {
      this.savedItems.forEach(section => {
        data.push({
          key: section.key,
          formTemplates: section.selected.map(item => ({
            id: item.id,
            multiple: item.multiple
          }))
        });
      });
    }
    return data;
  }

  getServiceStructure() {
    let convertedData: SectionGroupData[] = [];

    if (this.serviceAssignType === GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED)
      convertedData = this.convertSectionGroups();

    const serviceToAssing: Service = {
      internalName: (this.serviceTemplate as ServiceTemplateModel).internalName,
      category: (this.serviceTemplate as ServiceTemplateModel).category,
      cups: (this.serviceTemplate as ServiceTemplateModel).cups || "",
      type: (this.serviceTemplate as ServiceTemplateModel).type,
      priceLevel: this.priceLevel,
      user: (this.userChosen as UserStatus).id,
      serviceTemplate: (this.serviceTemplate as ServiceTemplateModel).id || "",
      progress: 0,
      carer: "",
      attendedBy: "",
      medicalOrder: "",
      state: SERVICE_STATES.NOT_ASSIGNED
    };

    if (
      (this.serviceTemplate as ServiceTemplateModel).type ===
      GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TYPE
    ) {
      serviceToAssing.groups = convertedData;
      serviceToAssing.groupsFilled = {};
      serviceToAssing.sessionsFilled = {};
    } else {
      serviceToAssing.sections = convertedData;
      serviceToAssing.sectionsFilled = {};
      serviceToAssing.formTemplatesFilled = {};
    }

    return serviceToAssing;
  }

  async saveOrder() {
    try {
      if (this.serviceTemplate === "") {
        Snackbar.popWarning(
          FORM_CONSTANTS.SNACKBAR_MESSAGES.AT_LEAST_ONE_SERVICE
        );
        return;
      }

      const service = this.getServiceStructure();

      const fieldsData = this.getFieldsModel();

      this.setPrice();

      const order: MedicalOrderModel = {
        user: (this.userChosen as UserStatus).id,
        cups: (this.serviceTemplate as ServiceTemplateModel).cups || "",
        priceLevel: this.priceLevel,
        billType: this.billType,
        state: this.orderState,
        campus: this.orderCampus,
        diagnosticPrimaryCode: this.diagnosticPrimaryCode,
        description: this.orderDescription,
        orderType: this.orderType,
        event: this.orderEvent,
        type: MEDICAL_ORDER_CONSTANTS.TYPE.SERVICE,
        payment: parseInt(this.orderServiceValue),
        cancelValue: this.orderCancelValue
          ? parseInt(this.orderCancelValue)
          : "",
        fields: fieldsData,
        serviceTemplate:
          (this.serviceTemplate as ServiceTemplateModel).id || "",
        nroMedicalOrder: this.orderExternalNumberValue,
        tracking: this.orderTracking
      };

      const responseData = await this.medicalOrderService.saveMedicalOrder(
        service,
        order
      );

      if (responseData.code == Http.Ok && !this.isOnModal) {
        Snackbar.popSuccess(responseData.message);
        this.$router.go(-1);
      } else if (responseData.code == Http.Ok && this.isOnModal) {
        Snackbar.popSuccess(responseData.message);
        this.clearModal();
        this.$emit(CLOSE_ORDER_MODAL);
      } else {
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MEDICAL_ORDER_ACCESS.POST}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  async viewServiceMessage(serviceTemplateId: string) {
    try {
      const response = await this.serviceTemplateService.getServiceTemplateById(
        serviceTemplateId
      );

      if (response.code === Http.Found && response.data) {
        this.componentStepperViewerKey++;
        this.serviceTemplateData = response.data;
        this.dialogStepperViewer = true;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICE_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  closeStepperViewer() {
    this.dialogStepperViewer = false;
  }
  async managePreSetUser() {
    this.userFilter = 2;
    this.searchUser = this.userId as string;

    await this.getUsers(false);
    if (this.listUsers.length > 0) {
      this.setUser(this.listUsers[0]);
    } else {
      this.clearModal();
      this.$emit(NO_PATIENT);
      this.handleModalAccept();
    }
  }
  clearModal() {
    this.listUsers = [];
    this.userChosen = "";
    this.cleanServiceConfig();
  }

  onRequiredComplete(valid: boolean) {
    this.validCustomFields = valid;
  }

  async getCupsByIds(arrayOfCups: string[]) {
    try {
      this.serviceCups = [];
      for (const cupsId of arrayOfCups) {
        const responseData = await this.cupsPriceLevelService.getCupsPriceLevelById(
          cupsId
        );
        if (
          responseData.code === Http.Found &&
          responseData.data !== undefined
        ) {
          this.serviceCups.push({
            key: responseData.data.id as string,
            value: responseData.data.externalName
          });
        }
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICE_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }
}
